import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/Layouts/NavFooterLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/Layouts/PageContentWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/PortfolioPage/PortfolioHeader/PortfolioHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/PortfolioPage/PortfolioTabs.tsx");
